<template>
	<div class="container">
		<div v-if="fileUrl">
			<iframe
				class="iframe_box"
				:src="fileUrl"
			></iframe>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { clutureList, } from '@/api/public';
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isTrue: null,
			fileUrl: '',
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		clutureList({
			id: 3,
		}).then(res => {
			that.fileUrl = res.data.url;
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.iframe_box{
	width: 100vw;
	height: 100vh;
}
</style>
